export default __webpack_public_path__ + "static/media/multmedi.d073e010.png";